import React from 'react';
import { UserContext } from '../../context/UserContext';
import ExternalContactPage from '../../views/contact/ExternalContactPage';
import LoadingScreen from '../shared/loading/LoadingScreen';
import InternalContactPage from '../../views/contact/InternalContactPage';

const ContactWrapper = () => {
  const { authenticated } = React.useContext(UserContext);

  if (authenticated === null) return <LoadingScreen />;

  return authenticated ? <InternalContactPage /> : <ExternalContactPage />;
};

export default ContactWrapper;
